// extracted by mini-css-extract-plugin
module.exports = {"editQuestionControls":"EditQuestionControls_editQuestionControls__LMEtH","deleteButton":"EditQuestionControls_deleteButton__2WUBk","tooltip":"EditQuestionControls_tooltip__1Vu-H"};